import Vue from "vue";
import "./plugins/validate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import api from "./api";
import i18n from "./i18n";
import _ from "lodash";
import bus from "@/plugins/eventbus";
import Time from "@/plugins/time";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Time);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype._ = _;
Vue.prototype.$api = api;
Vue.prototype.$bus = bus;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
